module.exports = __webpack_public_path__ + "img/step1-3.276f8e83.png";